import type { TeamSummary } from "../../shared/types";
import { formatLocalMatchTime } from "../lib/dates";
import OwnerTag from "./OwnerTag";

function formatGD(n: number) {
  if (n > 0) return `+${n}`;
  return String(n);
}

export default function TeamCard({
  team,
  showOwner = true,
}: {
  team: TeamSummary;
  showOwner?: boolean;
}) {
  const status = team.eliminated ? "Eliminated" : "Active";
  const group = team.group ? formatGroupLabel(team.group) : null;

  const next = team.nextFixture;
  const nextLine = next
    ? `Next: ${
        next.homeTeam === team.team ? "v " + next.awayTeam : "v " + next.homeTeam
      }${next.stage === "Group stage" ? "" : ` · ${next.stage}`} · ${formatLocalMatchTime(
        next.dateUtc
      )}`
    : null;

  return (
    <div className={`team-card${team.eliminated ? " eliminated" : ""}`}>
      <div className="team-name">
        {team.team}
        {showOwner && team.owner ? (
          <>
            {" "}
            <OwnerTag owner={team.owner} />
          </>
        ) : null}
      </div>
      <div className="team-meta">
        {status}
        {group ? ` · ${group}` : null}
      </div>
      <div className="team-stats">
        P {team.played} · W {team.won} · D {team.drawn} · L {team.lost}
        {" · "}GF {team.goalsFor} · GA {team.goalsAgainst} · GD{" "}
        {formatGD(team.goalDifference)} · Pts {team.points}
      </div>
      {nextLine ? <div className="team-meta">{nextLine}</div> : null}
    </div>
  );
}

function formatGroupLabel(group: string): string {
  if (group.startsWith("GROUP_")) return `Group ${group.slice(6)}`;
  return group;
}
